// BOOTSTRAP CORE COMPONENTS
import Button from './bs/src/button';
import Dropdown from './bs/src/dropdown';
import Collapse from './bs/src/collapse';
import Offcanvas from './bs/src/offcanvas';
import Alert from './bs/src/alert';
import Carousel from './bs/src/carousel';
import Modal from './bs/src/modal';
import Popover from './bs/src/popover';
import ScrollSpy from './bs/src/scrollspy';
import Tab from './bs/src/tab';
import Tooltip from './bs/src/tooltip';
import Toast from './bs/src/toast';

// MDB COMPONENTS
import Ripple from './mdb/ripple';
import Datepicker from './mdb/datepicker';
import Timepicker from './mdb/timepicker';
import Stepper from './mdb/stepper';

window.Alert = Alert;
window.Button = Button;
window.Dropdown = Dropdown;
window.Carousel = Carousel;
window.Collapse = Collapse;
window.Offcanvas = Offcanvas;
window.Modal = Modal;
window.Popover = Popover;
window.ScrollSpy = ScrollSpy;
window.Tab = Tab;
window.Toast = Toast;
window.Tooltip = Tooltip;
window.Ripple = Ripple;
window.Datepicker = Datepicker;
window.Timepicker = Timepicker;
window.Stepper = Stepper;
